import {
  faEllipsis,
  faTrashAlt,
  faUserMinus,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppDispatch } from "Store/hooks";
import { setErrorState } from "Components/Basic/ErrorBoundary/redux/slice";
import { Dropdown, MenuProps, Popconfirm } from "antd";
import { setLoadingState } from "Components/Basic/full_page_loader/redux/slice";
import { deleteUser, getAllUsers, updateUser } from "../../redux/thunks";
import "Features/Users/users.index.css";
import { cloneDeep } from "lodash";
import { Platform } from "Features/Users/redux/types";
import { createRoleInXml, parseRolesFromXML } from "Utilities/common";

export const ActionRenderer = (_: any, record: any) => {
  const dispatch = useAppDispatch();
  const isAdmin = parseRolesFromXML(record.xmlData ?? "").includes(
    "SUPERADMIN"
  );

  const deleteSelectedUser = async () => {
    try {
      dispatch(setLoadingState(true));
      await dispatch(deleteUser(record)).unwrap();
      dispatch(
        setErrorState({
          message: "Success",
          description: "User deleted successfully",
          placement: "topRight",
          type: "success",
        })
      );
    } catch (err: any) {
      dispatch(
        setErrorState({
          message: "Error",
          description: err.message,
          placement: "topRight",
          type: "error",
        })
      );
    } finally {
      dispatch(setLoadingState(false));
    }
  };

  const handleDelete = () => {
    deleteSelectedUser();
  };

  const handleMakeAdmin = async () => {
    try {
      dispatch(setLoadingState(true));
      const user = cloneDeep(record);
      const roles = parseRolesFromXML(user.xmlData ?? "");
      const newRoles = isAdmin
        ? roles.filter((role: string) => role !== "SUPERADMIN")
        : [...roles, "SUPERADMIN"];

      if (record.platform === Platform.TenantManagementPortal) {
        user.platform = Platform.SelfServicePortal;
      } else {
        user.platform = Platform.TenantManagementPortal;
      }

      user.xmlData = createRoleInXml(newRoles);

      await dispatch(updateUser(user)).unwrap();
      await dispatch(getAllUsers()).unwrap();

      dispatch(
        setErrorState({
          message: "Success",
          description: !isAdmin
            ? "User is now an admin"
            : "User is now a normal user",
          placement: "topRight",
          type: "success",
        })
      );
    } catch (err: any) {
      dispatch(
        setErrorState({
          message: "Error",
          description: err.message,
          placement: "topRight",
          type: "error",
        })
      );
    } finally {
      dispatch(setLoadingState(false));
    }
  };

  const items: MenuProps["items"] = [
    {
      label: (
        <Popconfirm
          title={"Delete User"}
          description={"Are you sure you want to delete this user?"}
          onConfirm={handleDelete}
        >
          <div className={"action-items action-items-red"}>
            <FontAwesomeIcon
              className="action-items-icon action-items-icon-red"
              icon={faTrashAlt}
            />
            Delete User
          </div>
        </Popconfirm>
      ),
      danger: true,
      key: "1",
    },
    {
      label: (
        <Popconfirm
          title={!isAdmin ? "Make Admin" : "Remove Admin"}
          description={
            !isAdmin
              ? "Are you sure you want to make this user an admin?"
              : "Are you sure you want to remove this user as an admin?"
          }
          onConfirm={handleMakeAdmin}
        >
          <div>
            <FontAwesomeIcon
              className="action-items-icon"
              icon={!isAdmin ? faUserPlus : faUserMinus}
            />
            {!isAdmin ? "Make Admin" : "Remove Admin"}
          </div>
        </Popconfirm>
      ),
      key: "2",
    },
  ];
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Dropdown menu={{ items }} trigger={["click"]}>
        <FontAwesomeIcon
          style={{ cursor: "pointer" }}
          icon={faEllipsis}
          rotation={90}
        />
      </Dropdown>
    </div>
  );
};
